import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
interface SectionProps {
  id?: string;
  children: ReactNode;
  className?: string;
  /** Aria label para acessibilidade */
  "aria-label"?: string;
}

/**
 * Wrapper de seção com padding e largura consistente.
 * Responsabilidade única: layout de seção.
 */
export function Section(t0) {
  const $ = _c(5);
  const {
    id,
    children,
    className: t1,
    "aria-label": ariaLabel
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `mx-auto max-w-6xl px-6 py-6 sm:py-5 md:py-10 ${className}`;
  let t3;
  if ($[0] !== ariaLabel || $[1] !== children || $[2] !== id || $[3] !== t2) {
    t3 = <section id={id} className={t2} aria-label={ariaLabel}>{children}</section>;
    $[0] = ariaLabel;
    $[1] = children;
    $[2] = id;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}